import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { ApiBaseError, DataList, Deal } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class DealService {
  constructor(private apiService: ApiService) {}

  listAvailable(length: number = 25): Observable<DataList<Deal>> {
    return this.apiService.get<DataList<Deal>>(`user/deals?length=${length}`).pipe();
  }

  listActive(length: number = 25): Observable<DataList<Deal>> {
    return this.apiService.get<DataList<Deal>>(`user/deals/active?length=${length}`).pipe();
  }

  listFrontdeskAvailable(length: number = 25): Observable<DataList<Deal>> {
    return this.apiService.get<DataList<Deal>>(`frontdesk/deals?length=${length}`).pipe();
  }

  listFrontdeskActive(length: number = 25): Observable<DataList<Deal>> {
    return this.apiService.get<DataList<Deal>>(`frontdesk/deals/active?length=${length}`).pipe();
  }

  showFrontdesk(id: number): Observable<Deal> {
    return this.apiService.get<Deal>(`frontdesk/deals/${id}`).pipe();
  }

  add(code: string): Observable<ApiBaseError> {
    return this.apiService.post<ApiBaseError>(`user/deals`, { code: code }).pipe();
  }

  show(id: number): Observable<Deal> {
    return this.apiService.get<Deal>(`user/deals/${id}`).pipe();
  }
}
